import { render, staticRenderFns } from "./BaseLoaderDefault.vue?vue&type=template&id=a3b87e14&scoped=true&functional=true&"
import script from "./BaseLoaderDefault.vue?vue&type=script&lang=js&"
export * from "./BaseLoaderDefault.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoaderDefault.vue?vue&type=style&index=0&id=a3b87e14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a3b87e14",
  null
  
)

export default component.exports